import { type FeatureFlags } from '@app/store/types/features';

export function splitFeatureFlag(key) {
    return key
        .split(/(?=[A-Z])/)
        .join(' ')
        .toLowerCase();
}

export function toggleFeatureFlag(key, features) {
    const newFlags: FeatureFlags = { ...features };
    newFlags[key] = !newFlags[key];

    return newFlags;
}
